import { useEffect, useState } from 'react';

const DISMISS_KEY = 'wdgm-cup-install-prompt-dismissed';

const isStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

function InstallAppPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    if (isStandaloneMode() || window.localStorage.getItem(DISMISS_KEY) === 'true') {
      return undefined;
    }

    const userAgent = window.navigator.userAgent || '';
    const iosDevice = /iphone|ipad|ipod/i.test(userAgent);
    const mobileDevice = /android|iphone|ipad|ipod/i.test(userAgent);

    if (!mobileDevice) {
      return undefined;
    }

    setIsIos(iosDevice);

    if (iosDevice) {
      setShowPrompt(true);
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowPrompt(true);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setShowPrompt(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleDismiss = () => {
    window.localStorage.setItem(DISMISS_KEY, 'true');
    setShowPrompt(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();
    await deferredPrompt.userChoice.catch(() => null);
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt || isStandaloneMode()) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-[70] flex justify-center px-4 sm:bottom-6">
      <div className="w-full max-w-md rounded-[28px] border border-cyan-300/25 bg-slate-950/95 p-4 shadow-[0_20px_70px_-25px_rgba(8,145,178,0.55)] backdrop-blur">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300">Asenna sovellus</p>
        <p className="mt-2 text-sm leading-6 text-slate-100">
          {isIos
            ? 'Avaa Safarin jakovalikko ja valitse Lisaa Koti-valikkoon, niin saat sivun puhelimeen sovelluksena.'
            : 'Asenna WDGM Cup puhelimeesi, niin saat sen avattua kuten sovelluksen omalta kuvakkeelta.'}
        </p>

        <div className="mt-4 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={handleDismiss}
            className="rounded-full border border-white/10 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:bg-white/10"
          >
            Ei nyt
          </button>
          {!isIos && deferredPrompt ? (
            <button
              type="button"
              onClick={handleInstall}
              className="rounded-full bg-cyan-400 px-4 py-2 text-sm font-bold text-slate-950 transition hover:bg-cyan-300"
            >
              Asenna
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default InstallAppPrompt;